import Settings from '../../views/settings/Settings.vue'

const route = {
    path: '/:account_id/settings',
    name: 'settings',
    component: Settings,
    children: []
}

export default route
